export default {
  regular: 'Roboto-Regular',
  bold: 'Roboto-Bold',
  light: 'Roboto-Light',
  'din-bold': 'DINNext79-Bold',
  'din-bold-cn': 'DINNext79-CnBold',
  'din-regular': 'DINNext79-Regular',
  'din-medium': 'DINNext79-Md',
  'din-medium-cn': 'DINNext79-MdCn',
  'din-light': 'DINNext79-Lt',
  'din-light-cn': 'DINNext79-LtCn',
}
